'use client'

import { getThemeProvider } from '@rybr/styled-modules'

import { prefixedTheme } from './theme'

// Must use a middle-man here - cannot export the decomposed response
// If you try 'export { ThemeProvider, RenderThemeStyleSheet, ...etc } = getThemeProvider(...)'
// it fails to correctly import in other files
const themeStuff = getThemeProvider(prefixedTheme, 'rona')

export const ThemeProvider = themeStuff.ThemeProvider
export const RenderThemeStylesheet = themeStuff.RenderThemeStylesheet
export const themeContext = themeStuff.themeContext
export const useTheme = themeStuff.useTheme
